const planogramm = {
     number: 0,
     amount: 0,
     type: 0,
}

export const planogrammExt = {
    nomenclature: '',
    tax: 0,
    price_cash: 0,
    price_cashless: 0,
    group_number: 0, // 'Номер колонки' для type 7,
    equipment: '',
    scenario: '',
    description: '',
    descriptionType: 0,
    ...planogramm
}
